import { adminListingQueryKeys as e } from "./adminListingQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminListingsApi as r } from "@maat/api-main";
//#region src/listings/admin/useAdminSetListingSuspensionMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, suspend: t, reason: n }) => r.setListingSuspension(e, {
			suspend: t,
			reason: n
		}),
		onSuccess: (t, { id: n }) => {
			i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useAdminSetListingSuspensionMutation };
